export function translateWithRegexMap(text: string, map: { regex: RegExp; text: string }[], fallback: string = text) {
  for (const item of map) {
    if (item.regex.test(text)) {
      return item.text
    }
  }

  return fallback
}

export function capitalizeFirstLetter(text: string) {
  return text.charAt(0).toUpperCase() + text.slice(1).toLocaleLowerCase()
}

export function semverString(opts: {
  version?: string | null
  build?: string | null
  preRelease?: string | null
  sha?: string | null
  env?: string | null
}) {
  let semver = opts.version ?? '0.0.0'

  if (opts.preRelease) {
    semver += `-${opts.preRelease}`
  }

  const metadata = [opts.build, opts.sha, opts.env].filter(Boolean).join('.')

  if (metadata) {
    semver += `+${metadata}`
  }

  return semver
}
